import { useRef, useEffect } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const ColorPickerShim = ({
  color,
  onChange,
  panelOpen
}) => {
  const inputEl = useRef(null);
  useEffect(() => {
    if (panelOpen && inputEl.current) inputEl.current.click();
  }, [panelOpen]);
  return /*#__PURE__*/_jsx("input", {
    type: "color",
    value: color,
    onChange: onChange,
    ref: inputEl
  });
};